<template>
    <div class="sa-list-component" style="height: 100%;">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ agendeProcessate.length }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="agendeProcessate.length" :per-page="perPage"
                        align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>

        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="agendeProcessate" :fields="fields"
                    :current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light"
                    class="sa-b-table">

                    <template #cell(espandi)="row">
                        <b-button size="sm" variant="outline-primary" @click="row.toggleDetails">
                            <i :class="row.detailsShowing ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                        </b-button>
                    </template>

                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + (row.index + 1) }}
                    </template>

                    <template #cell(riferimento)="">
                        <b>{{ riferimento.split("-").reverse().join("/") }}</b>
                    </template>

                    <template #cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button size="sm" class="mr-3" v-b-tooltip.hover :title="`Stampa`" variant="outline-info"
                                @click="onClickStampaFoglioLavoro(row.item)">
                                🖨️
                            </b-button>
                        </b-container>
                    </template>

                    <template #row-details="row">
                        <b-card class="m-3 shadow-sm bg-light">
                            <template #header>
                                <label style="text-transform: uppercase;">
                                    {{ `Appuntamenti in questa Agenda per il giorno:` }}
                                    <span style="font-weight: bold !important; font-style: italic; font-size: larger;">
                                        {{ riferimento }}
                                    </span>
                                </label>
                            </template>

                            <b-table striped hover small :items="row.item.appuntamenti" :fields="campiAppuntamenti">
                                <template #cell(indexSub)="subRow">
                                    {{ subRow.index + 1 }}
                                </template>

                                <template #cell(identificativoAppuntamento)="subRow">
                                    <label class="w-100 m-0">{{ subRow.item.cognome }} {{ subRow.item.nome }}</label>
                                    <small style="font-weight: bolder;">{{ subRow.item.identificativoAppuntamento
                                        }}</small>
                                </template>

                                <template #cell(dataOraInizio)="subRow">
                                    <strong class="w-100">
                                        {{ formatDate(subRow.item.dataRiferimento) }} {{
                                            formatTime(subRow.item.dataOraInizio) }}
                                    </strong>
                                </template>

                                <template #cell(dataOraFine)="subRow">
                                    <strong class="w-100">
                                        {{ formatDate(subRow.item.dataRiferimento) }} {{
                                            formatTime(subRow.item.dataOraFine) }}
                                    </strong>
                                </template>
                                <template #cell(tipologiaVisita)="subRow">
                                    <span :class="{ color: getColorAppuntamentoTipo(subRow.item.tipologiaVisita) }"> {{
                                        subRow.item.tipologiaVisita }}</span>

                                </template>

                                <template #cell(descrizionePrestazione)="subRow">
                                    <label class="w-100 m-0">{{ subRow.item.descrizionePrestazione }}</label>
                                    <small style="font-weight: bolder;">{{ subRow.item.codicePrestazione }}</small>
                                </template>

                                <template #cell(actions)="subRow">
                                    <b-container class="bv-example-row p-0">
                                        <b-button size="sm" class="mr-2" v-b-tooltip.hover title="Cambio Stato"
                                            variant="outline-info" @click="onClickCambioStato(subRow.item)">
                                            🔄
                                        </b-button>
                                        <b-button size="sm" v-b-tooltip.hover title="Sposta Appuntamento"
                                            variant="outline-info" @click="onClickSpostaAppuntamento(subRow.item)">
                                            📆
                                        </b-button>
                                    </b-container>
                                </template>
                            </b-table>
                        </b-card>
                    </template>
                </b-table>
            </div>
        </div>

        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ agendeProcessate.length }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="agendeProcessate.length" :per-page="perPage"
                        align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>

        <b-modal ref="mdlCambioStato" title="Cambia Stato Appuntamento" size="xl">
            <template #modal-footer>
                <div style="display: flex; gap: 6px; justify-content: flex-end; align-items: center">
                    <b-button variant="secondary" @click="onCloseModal()">Chiudi</b-button>
                    <b-button variant="primary" @click="onConferma()">Salva</b-button>
                </div>
            </template>
        </b-modal>

        <b-modal ref="mdlSpostaAppuntamento" title="Sposta Appuntamento" size="xl">
            <template #modal-footer>
                <div style="display: flex; gap: 6px; justify-content: flex-end; align-items: center">
                    <b-button variant="secondary" @click="onCloseModal()">Chiudi</b-button>
                    <b-button variant="primary" @click="onConferma()">Salva</b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";
import moment from "moment";

export default {
    mixins: [UtilityMixin],
    props: {
        riferimento: {
            type: String,
            default: () => moment(new Date()).format("DD-MM-YYYY"),
        }
    },
    mounted() {
        this.loadDataAgendaAppuntamentoPagamentoStati();
        this.loadDataSpecializzazioni();
        this.loadDataTipologieAgende();
        this.loadStatiAgenda();
    },
    data() {
        return {
            tipologieAgendaOptions: [],
            statiPagamentiAppuntamento: [],
            tipologiaVisitaOptions: [],
            statiAppuntamentoOptions: [],
            specializzazioniOptions: [],
            pathResourceAgendaAppuntamenti: "/agendaappuntamenti",
            agendeSelezionateCaricate: [], // <--- Ora manteniamo qui le agende reali strutturate
            perPage: 2,
            currentPage: 1,
            fields: [
                {
                    key: "espandi",
                    label: "Espandi",
                    thStyle: "width: 4rem",
                    class: "text-center"
                },
                {
                    key: "index",
                    label: "#",
                    thStyle: "width: 3rem",
                },
                {
                    key: "nomeAgenda",
                    label: "Nome Agenda",
                    formatter: (value) => value ? value.toUpperCase() : "",
                    sortable: true,
                },
                {
                    key: "riferimento",
                    label: "Data Riferimento",
                },
                {
                    key: "conteggio",
                    label: "Tot. Appuntamenti",
                    class: "text-center"
                },
                { key: "actions", label: "Azioni", class: "text-center" }
            ],
            campiAppuntamenti: [
                { key: "indexSub", label: "#", thStyle: "width: 3rem" },
                { key: "identificativoAppuntamento", label: "ID Appuntamento" },
                { key: "tipologiaVisita", label: "Tipo Visita" },
                { key: "descrizionePrestazione", label: "Prestazione" },
                { key: "statoAttuale", label: "Stato" },
                {
                    key: "dataOraInizio",
                    label: "Ora Inizio",
                    formatter: (value) => value ? moment(new Date(value)).format("HH:mm") : "-"
                },
                {
                    key: "dataOraFine",
                    label: "Ora Fine",
                    formatter: (value) => value ? moment(new Date(value)).format("HH:mm") : "-"
                },
                { key: "note", label: "Note" },
                { key: "actions", label: "Azioni", class: "text-center" }
            ]
        };
    },
    computed: {
        // Ritorna la lista pronta per essere paginata da b-table
        agendeProcessate() {
            return this.agendeSelezionateCaricate;
        }
    },
    methods: {
        // Metodo di inizializzazione chiamato dal padre
        init(agende, agendeSelezionate) {
            this.agendeSelezionateCaricate = [];

            if (agendeSelezionate && agendeSelezionate.length > 0) {
                for (let idSel of agendeSelezionate) {
                    const agendaReale = agende.find(a => a.id === idSel);

                    if (agendaReale) {
                        // Iniettiamo l'agenda con la struttura pulita richiesta dalla tabella
                        this.agendeSelezionateCaricate.push({
                            idAgenda: agendaReale.id,
                            nomeAgenda: agendaReale.titolo || `Agenda ${agendaReale.id}`,
                            conteggio: agendaReale.appuntamenti ? agendaReale.appuntamenti.length : 0,
                            appuntamenti: agendaReale.appuntamenti || [],// Sotto-tabella estrae da qui,
                            agenda: agendaReale
                        });
                    } else {
                        console.warn(`Nessuna agenda trovata con ID: ${idSel}`);
                    }
                }
            }
        },

        openCambioStato() {
            this.$refs.mdlCambioStato.show();
        },
        openCambioData() {
            this.$refs.mdlSpostaAppuntamento.show();
        },
        onClickCambioStato(item) {
            this.openCambioStato();
            console.log("Cambio stato per:", item);
        },
        onClickSpostaAppuntamento(item) {
            this.openCambioData();
            console.log("Sposta appuntamento:", item);
        },
        onClickStampaFoglioLavoro(item) {
            console.log("Stampa foglio lavoro per l'agenda:", item);
        },
        loadDataTipologieAgende() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/agendatipo";
            me.showModalLoading = true;
            axios
                .get(link)
                .then((response) => {
                    this.tipologieAgendaOptions = response.data.data.list;

                })
                .catch(() => { });

        },
        loadStatiAgenda() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/agendaappuntamentistati";
            me.showModalLoading = true;
            axios
                .get(link)
                .then((response) => {
                    this.statiAppuntamentoOptions = response.data.data.list;

                })
                .catch(() => { });
        },
        loadDataSpecializzazioni() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/agendaspecializzazione";
            me.showModalLoading = true;
            axios
                .get(link)
                .then((response) => {
                    this.specializzazioniOptions = response.data.data.list;

                })
                .catch(() => { });

        },
        loadDataAgendaAppuntamentoPagamentoStati() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/agendaappuntamentipagamentistati";
            me.showModalLoading = true;
            axios
                .get(link)
                .then((response) => {
                    this.statiPagamentiAppuntamento = response.data.data.list;

                })
                .catch(() => { });

        },
        getColorBorder(agenda) {
            let color = "";

            console.log(agenda);

            let a = this.tipologieAgendaOptions.find(e => e.nome == agenda)
            if (a) {
                color = a.color;
            }
            return color;
        },
        getColorAppuntamentoTipo(tipovisita) {
            let color = "";
            let a = this.tipologiaVisitaOptions.find(e => e.nome == tipovisita)
            if (a) {
                color = a.color;
            }
            return color;

        },
        getColorAppuntamentoStatoApp(app) {
            console.log(app);

            let color = "";
            let a = this.statiAppuntamentoOptions.find(e => e.nome == app.statoAttuale)
            if (a) {
                color = a.color;
            }
            return color;
        },


        getIconaByStato(appstato) {
            let icon = "";
            let a = this.statiAppuntamentoOptions.find(e => e.nome == appstato)
            if (a) {
                icon = a.icon;
            }
            return icon;


        },
        getIconaByStatoPagamento(statoPagamento) {
            console.log(statoPagamento);

            let icon = "";
            let a = this.statiPagamentiAppuntamento.find(e => e.nome == statoPagamento)
            if (a) {
                icon = a.icon;
            }
            return icon;


        },


        getColorSpecializzazione(agenda) {
            let color = "";
            let a = this.specializzazioniOptions.find(e => e.nome == agenda.specializzazione)
            if (a) {
                color = a.color;
            }
            return color;

        },
    },
};
</script>